<template>
  <div class="registerPage">
    <div class="homebg">
      <img src="../assets/sharedHome/share_bg1.png" alt />
    </div>
    <div class="bigBg">
      <div class="publicBox">
        <div class="yellowArticle">
          <img src="../assets/sharedHome/share_title1.png" alt />
        </div>
        <div class="publicWhiteBox">
          <div class="publicTitleBox box_c">
            <!-- <img src="../assets/home/title_left.png" alt />
            <span v-if="!hasCoupon &&!isGetCoupon">注册领取礼包</span>
            <span v-else-if="hasCoupon &&!isGetCoupon">领取成功</span>
            <span v-else-if="!hasCoupon && isGetCoupon">已领取</span>
            <img src="../assets/home/title_right.png" alt /> -->
          </div>
          <div class="registerBox" v-if="!hasCoupon &&!isGetCoupon">
            <div class="phoneBox box_c">
              <input type="number" v-model="phone" placeholder="您的手机号" @input="getPhone" />
            </div>
            <!-- <div class="codeBox box_cqh">
              <div class="codeInput box_c">
                <input type="input" v-model="code" placeholder="短信验证码" />
              </div>
              <div class="sendBtn box_c" @click="sendCode" v-if="!lodingCode">获取验证码</div>
              <div class="sendBtn box_c loading" v-else>{{s}}s后重获验证码</div>
            </div>-->
            <div class="errorValue">{{errorValue}}</div>
            <div class="registerBtn box_c" @click="getCoupon">立即领取</div>
            <div class="protocalBox txt">
              注册即代表您同意
              <router-link to="/protocal">《飞游云用户协议》</router-link>
            </div>
          </div>
          <div class="hasCouponBox txt" v-else-if="hasCoupon &&!isGetCoupon">
            <img src="../assets/register/coupon_ic_success.png" alt />
            <div class="successVlaue">领取成功，扫一扫即可使用！</div>
            <div class="successHint">优惠券已放入您的账户，请前往飞游无人机小程序使用</div>
          </div>
          <div class="hasCouponBox txt" v-else-if="!hasCoupon && isGetCoupon">
            <img src="../assets/register/coupon_ic_success.png" alt />
            <div class="successVlaue">您已领取过优惠券，快去扫一扫使用吧！</div>
            <div class="successHint">优惠券已放入您的账户，请前往飞游无人机小程序使用</div>
          </div>
        </div>
      </div>
      <div class="publicBox">
        <div class="yellowArticle center">
          <img src="../assets/sharedHome/share_title2.png" alt />
        </div>
        <div class="publicWhiteBox" style="padding:18px 40px">
          <div class="box_cqh listBox">
            <div class="step">
              <div class="imgView">
                <div class="imgs">
                  <img src="../assets/sharedHome/share_ic1.png" alt />
                </div>
              </div>
              <div class="imgViewBottom box">
                <div class="num">01</div>
                <div class="stepTxt">
                  <div>手机扫码,</div>
                  <div>选择机器</div>
                </div>
              </div>
            </div>

            <div class="step">
              <div class="arrow">
                <img src="../assets/sharedHome/share_arrow_left.png" alt />
              </div>
            </div>

            <div class="step">
              <div class="imgView">
                <div class="imgs">
                  <img src="../assets/sharedHome/share_ic2.png" alt />
                </div>
              </div>
              <div class="imgViewBottom box">
                <div class="num">02</div>
                <div class="stepTxt">
                  <div>手机下单,</div>
                  <div>柜门打开</div>
                </div>
              </div>
            </div>
          </div>
          <div class="listBox listRight">
            <div class="step">
              <div class="arrow">
                <img src="../assets/sharedHome/share_arrow_down.png" alt />
              </div>
            </div>
          </div>
          <div class="box_cqh listBox">
            <div class="step">
              <div class="imgView">
                <div class="imgs">
                  <img src="../assets/sharedHome/share_ic4.png" alt />
                </div>
              </div>
              <div class="imgViewBottom box">
                <div class="num">04</div>
                <div class="stepTxt">
                  <div>扫码归还,</div>
                  <div>关闭柜门</div>
                </div>
              </div>
            </div>

            <div class="step">
              <div class="arrow">
                <img src="../assets/sharedHome/share_arrow_left.png" class="spinImg" alt />
              </div>
            </div>

            <div class="step">
              <div class="imgView">
                <div class="imgs">
                  <img src="../assets/sharedHome/share_ic3.png" alt />
                </div>
              </div>
              <div class="imgViewBottom box">
                <div class="num">03</div>
                <div class="stepTxt">
                  <div>取走机器,</div>
                  <div>关闭柜门</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="publicBox">
        <div class="publicWhiteBox">
          <div class="codeBox box_cqh">
            <div class="codeLeft">
              <div class="title">关注公众号获取更多资讯</div>
              <div class="titleHint">
                <span>长按识别二维码</span>
                <img src="../assets/sharedHome/share_arrow1.png" alt />
                <img src="../assets/sharedHome/share_arrow2.png" alt />
              </div>
            </div>
            <div class="codeRight">
              <img src="../assets/sharedHome/share_offical.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var time = null;
let isAli ="";
import { Loading, Toast } from "vant";
import qs from "qs";
export default {
  data() {
    return {
      phone: "",
      code: "", //用户输入的验证码
      codeTrue: "", //真实的短信验证码
      errorValue: "",
      lodingCode: false, //是否正在倒计时
      hasCoupon: false, //是否领取成功
      isGetCoupon: false, //是否已领取
      s: 60,
      miniprogram: false, //是否在微信小程序
      isRequest: true //防止连续点击
    };
  },
  methods: {
    getPhone(e) {
      // console.log(e.target.value);
    },
    // 发送验证码
    sendCode() {
      let phone = this.phone;
      // console.log(phone);
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        // Toast('请输入正确的手机号码')
        this.errorValue = "请输入正确的手机号码";
        return false;
      } else {
        this.lodingCode = true;
        this.getCode(phone);
        this.countdown();
      }
    },
    // 倒计时
    countdown() {
      time = setInterval(() => {
        this.s--;
        if (this.s == 0) {
          clearInterval(time);
          this.time = null;
          this.lodingCode = false;
          this.s = 60;
        }
      }, 1000);
    },
    // 获取验证码
    getCode(phone) {
      this.$get("code/send?phone=" + phone).then(res => {
        console.log(res);
        if (res.code == 200) {
          Toast("验证码已发送到您的手机，请注意查收");
        }
      });
    },
    // 立即领取
    getCoupon() {
      if (this.isRequest) {
        this.isRequest = false;
        let data = {
          phone: this.phone,
          type: 2,
          activity_name:"share"
        };
        if (!/^1[3456789]\d{9}$/.test(this.phone)) {
          // Toast('请输入正确的手机号码')
          this.errorValue = "请输入正确的手机号码";
          this.isRequest = true;
          return false;
        }
        // if (this.code.trim().length == 0) {
        //   this.errorValue = "请输入验证码";
        //   this.isRequest = true;
        //   return false;
        // }
        Toast.loading("请稍后...");
        this.$post("ticket/user", qs.stringify(data))
          .then(res => {
            this.isRequest = true;
            Toast.clear();
            if (res.code == 200) {
              this.hasCoupon = true;
            } else if (res.code == 500 && res.msg == "用户已领取") {
              this.isGetCoupon = true;
            } else {
              Toast(res.msg);
            }
            console.log(res);
          })
          .catch(err => {
            this.isRequest = true;
            Toast.clear();
            console.log(err);
            Toast("未知错误，请检查网络是否连接");
          });
      } else {
        Toast("搞慢点~");
      }
    }
  },
  mounted() {
    let that = this;
    // 引入微信分享封装函数
    this.wxApi.wxRegister();
    var userAgent = navigator.userAgent;
    if (userAgent.indexOf('AlipayClient') > -1){
      isAli=true;
    }else{
      isAli=false;
    }
  },
  beforeDestroy() {
    clearInterval(time);
    this.time = null;
    this.lodingCode = false;
    this.s = 60;
  },
  destroyed() {
    clearInterval(time);
    this.time = null;
    this.lodingCode = false;
    this.s = 60;
  }
};
</script>

<style scoped lang='scss'>
@import "../common/font/font.css";
.registerPage {
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  background-color: #0084ff;
  .homebg {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .bigBg {
    position: relative;
    top: -47px;
  }
  .publicBox {
    width: 100%;
    padding: 0 11px;
    box-sizing: border-box;
    margin-bottom: 20px;
    .yellowArticle {
      width: 100%;
      text-align: center;
      font-size: 0;
      img {
        width: 136px;
      }
    }
    .publicWhiteBox {
      width: calc(100% - 12px);
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      border-radius: 5px;
      padding: 18px 15px;
      box-sizing: border-box;
      position: relative;
      // top: -30px;
      .publicTitleBox {
        width: 100%;
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: rgba(254, 36, 47, 1);
        margin-bottom: 25px;
        span {
          margin: 0 5px;
        }
        img {
          width: 14px;
        }
      }
      .registerBox {
        width: 100%;
        .phoneBox {
          width: 100%;
          padding: 0 15px;
          box-sizing: border-box;
          height: 41px;
          background: rgba(232, 232, 232, 1);
          border-radius: 5px;
          margin-bottom: 15px;
          input {
            width: 100%;
            outline: none;
            background: none;
            border: none;
            font-size: 13px;
          }
        }
        .codeBox {
          width: 100%;
          margin-bottom: 5px;
          .codeInput {
            flex: 5;
            padding: 0 15px;
            box-sizing: border-box;
            height: 41px;
            background: rgba(232, 232, 232, 1);
            border-radius: 5px;
            input {
              width: 100%;
              outline: none;
              background: none;
              border: none;
              font-size: 13px;
            }
          }
          .sendBtn {
            flex: 3;
            height: 41px;
            background: rgba(255, 224, 30, 1);
            border-radius: 5px;
            font-size: 13px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            margin-left: 10px;
          }
          .loading {
            font-size: 12px;
          }
        }
        .errorValue {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(255, 51, 51, 1);
          min-height: 15px;
          margin-bottom: 15px;
        }
        .registerBtn {
          width: 100%;
          height: 45px;
          background: url("../assets/register/btn_register.png") no-repeat;
          background-size: 100%;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          padding-bottom: 10px;
          box-sizing: border-box;
          img {
            width: 100%;
          }
        }
        .protocalBox {
          font-size: 11px;
          font-weight: 500;
          color: rgba(153, 153, 153, 1);
          margin: 10px auto;
          span {
            color: #1956ec;
          }
          a:visited {
            color: #1956ec;
          }
          a:link {
            color: #1956ec;
          }
          a:hover {
            color: #1956ec;
          }
        }
      }
      .hasCouponBox {
        width: 100%;
        img {
          width: 87px;
          margin-bottom: 15px;
        }
        .successVlaue {
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(254, 36, 47, 1);
          margin-bottom: 20px;
        }
        .successHint {
          font-size: 11px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
      }
      .listBox {
        width: 100%;
        .step {
          .arrow {
            width: 20px;
            height: 20px;
            img {
              width: 20px;
              height: 20px;
            }
            .spinImg {
              transform: rotate(180deg);
            }
          }
          .imgView {
            .imgs {
              width: 90px;
              height: 90px;
              margin-bottom: 10px;
              img {
                width: 90px;
                height: 90px;
              }
            }
          }
          .imgViewBottom {
            .num {
              font-family: "number";
              color: #0084ff;
              font-size: 20px;
              margin-right: 4px;
            }
            .stepTxt {
              font-size: 13px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #999999;
            }
          }
        }
      }
      .listRight {
        display: flex;
        justify-content: flex-end;
        .step {
          margin-top: 7px;
          margin-bottom: 6px;
          .arrow {
            width: 90px;
            text-align: center;
          }
        }
      }
      .codeBox {
        width: 100%;
        .codeLeft {
          .title {
            font-size: 16px;
            font-family: Source Han Sans CN;
            color: #333333;
            margin-bottom: 15px;
          }
          .titleHint {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #666666;
            span {
              margin-right: 6px;
            }
            img {
              width: 5px;
              height: 8px;
              margin-right: 3px;
            }
          }
        }
        .codeRight{
          img{
            width: 89px;
            height: 89px;
          }
        }
      }
      
    }
    //     .setpBg{
    //     background-color: #ffffff;
    //       background: url('../assets/register/activity_bg.png') no-repeat;
    //       background-size: cover;

    //   }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/sharedGetCoupon.vue